import { mean } from 'd3-array';
import { forEachObj } from '../../object-helpers';

export function positionCombinedTooltip(layout, tooltip, series, closestPoint, position = 'data') {

	// Find the width of the widest tooltip
	const tooltipDim = tooltip.container.node().getBoundingClientRect();

	const cursorPadding = 25;
	const plotAreaPadding = 5;

	if (position === 'top') {
		const rightPosition = closestPoint.x + cursorPadding;
		const rightLimit = layout.plotAreaX + layout.plotAreaWidth - plotAreaPadding;
		const displayOnRightSide = rightPosition + tooltipDim.width <= rightLimit;

		tooltip.container
			.style('left', (displayOnRightSide
				? rightPosition
				: closestPoint.x - tooltipDim.width - cursorPadding) + 'px')
			.style('top', (layout.plotAreaY + plotAreaPadding) + 'px');

		return;
	}

	// If the widest tooltip does not comfortably fit on the left side of the closest point,
	// we will display all tooltips on the right side of the closest data point instead
	const displayOnRightSide = closestPoint.x - tooltipDim.width - cursorPadding < layout.plotAreaX + plotAreaPadding;

	if (displayOnRightSide) {
		tooltip.container.style('left', (closestPoint.x + cursorPadding) + 'px');
	} else {
		tooltip.container.style('left', (closestPoint.x - tooltipDim.width - cursorPadding) + 'px');
	}

	const yValues = [];

	forEachObj(series, (name, s) => {
		const currentSeriesValue = s.config.dataAccessor(closestPoint.value);
		if (currentSeriesValue !== null) {
			const isRange = s.config.type === 'area' || s.config.type === 'range-bar';
			const y = s.associatedScale(isRange ? currentSeriesValue[1] : currentSeriesValue);
			yValues.push(y);
		}
	});

	if (yValues.length > 0) {

		const y = mean(yValues);

		let tooltipY = y - tooltipDim.height;

		if (tooltipY < layout.plotAreaY + plotAreaPadding) {
			tooltipY = layout.plotAreaY + plotAreaPadding;
		} else if (tooltipY + tooltipDim.height > layout.plotAreaY + layout.plotAreaHeight - plotAreaPadding) {
			tooltipY = layout.plotAreaY + layout.plotAreaHeight - tooltipDim.height - plotAreaPadding;
		}

		tooltip.container.style('top', tooltipY + 'px');

	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/position-combined-tooltip.js